module.exports = __webpack_public_path__ + "img/grid-display.065d8089.svg";